import React, { useState, useEffect } from "react";
import signOutWarning from "../../../Common/signOutWarning";
import { copyConfirmText } from "../../../Common/aiDisclaimer";
import { leftoverNamesNote } from "../../../Common/placeNaming";
import { guideShareLink } from "../../../Common/GuideLink";
import "./MobileHeader.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, regular, brands, icon } from "@fortawesome/fontawesome-svg-core/import.macro";
// import { Link } from "react-router-dom";
// import GuideInfo from "../../modals/GuideInfoXXX";
import logo from "../../../assets/images/logo1.jpg";

import DataBase, { logAnalyticsEvent } from "../../../dataBase/liquidGuides";
import Guide, { GuideAttributes } from "../../../Models/Guide";
import { stashConflictSnapshot } from "../../../Common/ConflictSnapshot";
import Place from "../../../Models/Place";
import { useDispatch } from "react-redux";
import { slice1Actions } from "../../../store/reducer";
import Common, { Settings, SortByEnum, AUTHORIZATION_LEVEL, COLORS } from "../../../Common/Common";
import { useSelector } from "react-redux";
import queryString from "query-string";
import { Link } from "react-router-dom";
import HTMLEditorModal from "../../modals/HTMLEditorModal";
import ImageUploadModal from "../../modals/ImageUploadModal";
import UserInfoModal from "../../modals/UserInfoModal";
import MenuModal from "../../modals/MenuModal";
import { openReportGuide, canReportGuide } from "../../modals/ReportGuideModal";
import LoginModal from "../../modals/LoginModal";
import AlertModal from "../../modals/AlertModal";
import SaveConflictDiffModal from "../../modals/SaveConflictDiffModal";
import GuideDownload from "../../modals/GuideDownload/GuideDownload";
import ImageDialog from "../../modals/ImageDialog";
import GroupsDialog from "../../modals/GroupsDialog";
import CategoriesDialog from "../../modals/CategoriesDialog";
import SectionsDialog from "../../modals/SectionsDialog";
import GuideEditModal from "../../modals/GuideEditModal";
import SettingsDialog from "../../modals/SettingsDialog";
import ReviewDialog from "../../modals/ReviewDialog";
import { DateTime } from "luxon";

import { urlSchemeToFunctions } from "../../../CommonWeb/Common";
//import { Offcanvas } from "react-bootstrap";

import User from "../../../Models/User";
import { planLinkPending } from "../../../Common/planLink";

const MobileHeader = (props) => {
  const [guideInfoModal, setGuideInfoModal] = useState(false);
  const [diffModalShow, setDiffModalShow] = useState(false);
  const [diffModalConflict, setDiffModalConflict] = useState(null);

  const [ShowHTMLEditorModal, setHTMLEditorModal] = useState(false);
  const [HTMLEditorModalContent, setHTMLEditorModalContent] = useState("");
  const [HTMLEditorModalCallback, setHTMLEditorModalCallback] = useState(null);

  const [ImageDialogShow, setImageDialogShow] = useState(false);
  const [ShowUserInfoModal, setUserInfoModal] = useState(false);
  const [ShowLoginModal, setShowLoginModal] = useState(false);
  const [LoginModalMode, setLoginModalMode] = useState("Login");

  const [MenuModalShow, setMenuModalShow] = useState(false);
  const [MenuModalImage, setMenuModalImage] = useState(null);
  const [MenuModalList, setMenuModalList] = useState([]);
  const [MenuModalHeading, setMenuModalHeading] = useState("");
  const [MenuModalPlace, setMenuModalPlace] = useState(null);
  const [MenuModalBackFn, setMenuModalBackFn] = useState(null);
  const [AlertModalShow, setAlertModalShow] = useState(false);
  const [AlertModalTitle, setAlertModalTitle] = useState("");
  const [AlertModalMessage, setAlertModalMessage] = useState("");
  const [AlertModalButtons, setAlertModalButtons] = useState([]);
  const [activityIndicator, setActivityIndicator] = useState(false);
  const [GuideDownloadShow, setGuideDownloadShow] = useState(false);
  const [GuideDownloadMode, setGuideDownloadMode] = useState("list");
  const [GuideDownloadType, setGuideDownloadType] = useState("read");

  const [GroupsDialogShow, setGroupsDialogShow] = useState(false);
  const [CategoriesDialogShow, setCategoriesDialogShow] = useState(false);
  const [SectionsDialogShow, setSectionsDialogShow] = useState(false);
  const [GuideEditModalShow, setGuideEditModalShow] = useState(false);
  const [GuideEditModalMode, setGuideEditModalMode] = useState("VIEW");
  const [SettingsDialogShow, setSettingsDialogShow] = useState(null);
  const [ReviewDialogShow, setReviewDialogShow] = useState(null);

  //const [guideInfoID, setGuideInfoID] = useState("");
  const [documentHTML, setdocumentHTML] = useState("");
  const dispatch = useDispatch();
  let creator_info = useSelector((state) => state.creator_info);
  let owner_info = useSelector((state) => state.owner_info);
  let user_info = useSelector((state) => state.user_info);
  let user_info_id = useSelector((state) => state.user_info_id);
  let AppSettings = useSelector((state) => state.AppSettings);
  let Authorization = useSelector((state) => state.Authorization);
  let PreviewingConflictSnapshot = useSelector((state) => state.PreviewingConflictSnapshot);
  // let guide_info = useSelector((state) => state.guide_info);
  let guide_meta = useSelector((state) => state.guide_meta);

  let HTMLStack = useSelector((state) => state.HTMLStack);
  let htmlString = useSelector((state) => state.homeScreen);
  let GuideSortOption = useSelector((state) => state.GuideSortOption);
  let MenuModalArgs = useSelector((state) => state.MenuModalArgs);
  let GuideStack = useSelector((state) => state.GuideStack);
  let NoAds = useSelector((state) => state.NoAds);
    let imageFolder = useSelector((state) => state.imageFolder);
  let GuideFormat = useSelector((state) => state.GuideFormat);
  let GuideSettings = useSelector((state) => state.GuideSettings);
  let ShowHiddenPlaces = useSelector((state) => state.ShowHiddenPlaces);

  //console.log("HomeHeader HTMLStack.length:", HTMLStack.length);

  //let search = window.location.search;
  // let params = new URLSearchParams(search);
  // let foo = params.get('query');
  //console.log(foo);

  const handleLoad = () => {
    //const parsed = queryString.parse(window.location.search);

    // if (typeof parsed.id != "undefined") loadGuide(parsed.id);
    // else loadGuide("IQrZiedo7oJWa9GgLR6L");
    DataBase.onAuthStateChanged(onAuthStateChanged);
  };

  useEffect(() => {
    window.addEventListener("load", handleLoad);
    return () => window.removeEventListener("load", handleLoad);
  }, []);
  window.loadGuide = loadGuide;

  // onComplete (optional): called with (success: boolean) once the load
  // settles — mirrors HomeHeader.js's identical addition for "View Latest
  // Version" (see purring-humming-mountain plan), which needs to know the
  // load actually succeeded before flipping on PreviewingConflictSnapshot.
  // Every existing caller omits it, so this is purely additive.
  function loadGuide(guide_info_id, onComplete) {
    //const guide_info_id = "wHvagurBLMmZ6zt4Cw6z"; // Imperia
    //const guide_info_id = "IQrZiedo7oJWa9GgLR6L"; // Florence
    dispatch(slice1Actions.SetLoadingGuide({ value: true }));
    setTimeout(timeoutFunc, 5000);
    DataBase.readGuideTransaction(guide_info_id, (res) => readGuideDataReturnNew(res, onComplete), "guest");
  }

  const timeoutFunc = () => {
    dispatch(slice1Actions.SetLoadingGuide({ value: false }));
  };

  const setGuideSortOption = (value) => {
    dispatch(slice1Actions.setGuideSortOption({ value: value }));
  };

  const readGuideDataReturnNew = (res, onComplete) => {
    let GuideObj = null;
    if (res.pass === true) {
      GuideObj = new Guide(res.guide_id);
      const guide_json = res.res.data;
      var guide_obj = JSON.parse(guide_json);
      const decoded = GuideObj.decodeGuideFb(guide_obj, res.infoDoc);
      if (decoded === true) {
        GuideObj.schedule.getPlaces_InSchedule();
        window.guide_obj = GuideObj;
        dispatch(
          slice1Actions.setGuide({
            guide: "new",
            guide_meta: { guide_info: res.infoDoc, guide_info_id: res.guide_info_id, guide_id: res.guide_id },
          })
        );
        dispatch(slice1Actions.setCreatorInfo({ value: res.creator_info }));
        dispatch(slice1Actions.setOwnerInfo({ value: res.owner_info }));
        dispatch(slice1Actions.pushGuideStack({ value: res.guide_info_id }));

        // dispatch(slice1Actions.setGuideInfo({ value: res.infoDoc }));
        // dispatch(slice1Actions.setAuthorization({ guide_info: res.infoDoc, uid: user_info.uid }));
        //dispatch(slice1Actions.setOwnerInfo({ value: res.user_info }));
        //console.log(res.owner_info);
      } else {
        console.log("decode failed");
      }
    } else {
      //console.log(res.res);
    }
    dispatch(slice1Actions.SetLoadingGuide({ value: false }));
    if (typeof onComplete === "function") onComplete(res.pass === true);
  };

  const onAuthStateChanged = (user) => {
    console.log("onAuthStateChanged", user);
    if (user) {
      User.findUserByUID(user.uid, findUserByUIDCallback);
    } else {
      const parsed = queryString.parse(window.location.search);
      let guide_to_load = "IQrZiedo7oJWa9GgLR6L";
      if (typeof parsed.id != "undefined") guide_to_load = parsed.id;
      if (!planLinkPending()) loadGuide(guide_to_load); // a Trip Builder trip opens instead (App.js)
    }
  };

  let user_info_retrieved = null;
  let guide_loaded = false;

  // Captured here (outer scope) since findUserByUIDCallback below declares
  // its own local `user_info` that shadows this one for its whole body.
  const wasGuestOrNullBeforeSignIn = user_info.uid == null || user_info.uid === "guest";

  const findUserByUIDCallback = async (res) => {
    console.log("findUserByUIDCallback", res);
    if (res.pass === true) {
      const user_info = res.res;
      user_info_retrieved = user_info;
      dispatch(slice1Actions.setUserInfo({ value: user_info }));
      dispatch(slice1Actions.setUserInfoId({ value: res.doc_id }));
      if (wasGuestOrNullBeforeSignIn && user_info.uid != null && user_info.uid !== "guest") {
        logAnalyticsEvent("login", { uid: user_info.uid });
      }
      console.log("findUserByUIDCallback", user_info.last_guide_id);
      if (user_info.last_guide_id !== "" && !guide_loaded) {
        guide_loaded = true;
        DataBase.doesGuideInfoExist(user_info.last_guide_id, doesGuideInfoExistCallback);
        return;
      }
    }
  };

  const doesGuideInfoExistCallback = (res) => {
    let guide_to_load = "IQrZiedo7oJWa9GgLR6L";
    //console.log("doesGuideInfoExistCallback", user_info.last_guide_id);
    if (res.pass === true) {
      guide_to_load = user_info_retrieved.last_guide_id;
    }
    const parsed = queryString.parse(window.location.search);
    if (typeof parsed.id != "undefined") guide_to_load = parsed.id;
    if (!planLinkPending()) loadGuide(guide_to_load); // a Trip Builder trip opens instead (App.js)
  };

  const purchaseTickets = () => {
    // Loaded from a fixed URL now, not AppSettings.tickets — opened directly
    // rather than fetched-and-injected, since fetching a different origin's
    // HTML would hit CORS unless andiamoplaces.com explicitly allows it.
    window.open("https://andiamoplaces.com/Docs/Tickets.html", "_blank");
  };

  const goBack = () => {
    //console.log("handleLeftArrow", HTMLStack.length);
    if (HTMLStack.length <= 1) {
      dispatch(slice1Actions.clearHTMLStack());
      //dispatch(slice1Actions.setShowHTMLReader({ value: false }));
      return;
    }
    const htmlString = HTMLStack[HTMLStack.length - 2];
    dispatch(slice1Actions.popHTMLStack());
    dispatch(slice1Actions.setHomeScreen({ value: htmlString }));
  };

  const HTMLEdit = () => {
    let html = window.guide_obj.document;
    if (html === null || html === "" || html === "<!-- Comment -->") {
      html = window.guide_obj.createGuideHTML();
    }
    setHTMLEditorModalContent(html);
    //setHTMLEditorModalCallback(HTMLEditCallback);
    setHTMLEditorModal(true);
  };

  const HTMLEditCallback = (html) => {
    console.log("HTMLEditCallback");
    window.guide_obj.document = html;
    dispatch(slice1Actions.clearHTMLStack());
    //dispatch(slice1Actions.popHTMLStack());
    dispatch(slice1Actions.setHomeScreen({ value: html }));
  };

  const ImageUpload = () => {
    setImageDialogShow(true);
  };

  const ImageDialogCallback = (res) => {
    console.log("ImageDialogCallback", res);
  };

  const myAlert = (message, title, buttons) => {
    setAlertModalMessage(message);
    setAlertModalTitle(title == null ? "Message" : title);
    setAlertModalButtons(buttons == null ? [{ Title: "OK", Method: null }] : buttons);
    setAlertModalShow(true);
  };

  const myConfirm = (message, buttons) => {
    setAlertModalTitle("Confirmation");
    setAlertModalMessage(message);
    setAlertModalButtons(buttons);
    setAlertModalShow(true);
  };

  const UserMenu = () => {
    const menuList = [
      {
        label: "Sign Out",
        method: logout,
        icon: null,
        visible: user_info.uid !== null && Authorization !== AUTHORIZATION_LEVEL.GUEST,
        info: "Log out from this app",
      },
      {
        label: "Reset Password",
        method: resetPassword,
        icon: null,
        visible: true,
        info: "Reset the password. An email will be sent to allow you to reset the password.",
      },
      {
        label: "User Details",
        method: showUserInfoModal,
        icon: null,
        visible: true,
        info: "Display the details of the logged in user, e.g. name, id etc.",
      },
      {
        label: "Settings",
        method: showSettingsDialog,
        icon: null,
        visible: true,
        info: "Change the settings for the logged in user of this app",
      },
      {
        label: "Sign In",
        method: showLogin,
        icon: null,
        visible: user_info.uid === null || Authorization === AUTHORIZATION_LEVEL.GUEST,
        info: "Login to this app. Note: you need to be logged in to: save changes, copy guide, create a guide, rate a guide or change settings",
      },
      {
        label: "Register",
        method: Register,
        icon: null,
        visible: user_info.uid === null || Authorization === AUTHORIZATION_LEVEL.GUEST,
        info: "Register for the app. Note that you need to register before you can log in and it's free of charge.",
      },
    ];
    setMenuModalBackFn(() => MainMenu);
    setMenuModalList(menuList);
    setMenuModalHeading("User Menu");
    setMenuModalImage(<FontAwesomeIcon icon={solid("user")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  const Register = () => {
    setLoginModalMode("Register");
    setShowLoginModal(true);
  };

  const showLogin = () => {
    setLoginModalMode("Login");
    setShowLoginModal(true);
  };

  const resetPassword = () => {
    setLoginModalMode("Forgot Password");
    setShowLoginModal(true);
  };

  const logout = () => {
    setAlertModalTitle("Confirmation");
    setAlertModalMessage("Do you want to log out?" + signOutWarning());
    setAlertModalButtons([
      { Title: "YES", Method: _logout },
      { Title: "NO", Method: _logout },
    ]);
    setAlertModalShow(true);
  };

  const _logout = (resp) => {
    if (resp !== "YES") return;
    setActivityIndicator(true);
    DataBase.Logout(logoutCallback);
  };

  const logoutCallback = (res) => {
    //console.log(res);
    setActivityIndicator(false);
    if (res.pass === true) {
      const user_info = {
        distance_unit: "kilometers",
        date_format: "Month first",
        edit_mode: false,
        email: "guest@gmail.com",
        first_name: "guest",
        last_name: "user",
        uid: "guest",
        create_date: "",
        modify_date: "",
        travel_payouts_marker: "",
      };
      dispatch(slice1Actions.setUserInfo({ value: user_info }));
      dispatch(slice1Actions.setUserInfoId({ value: null }));
      //dispatch(slice1Actions.setAuthorization({ guide_info: guide_info, uid: user_info.uid }));
    }
  };

  const showSettingsDialog = () => {
    setSettingsDialogShow(true);
  };

  const SettingsDialogCallback = (user_info) => {
    dispatch(slice1Actions.setUserInfo({ value: user_info }));
  };

  const GuideMenu = () => {
    const menuList = [
      {
        label: "Search Guides",
        method: DownloadGuide,
        icon: null,
        visible: true,
        info: "Search the available guides and download it to view.",
      },
      {
        label: "Previous Guide",
        method: PreviousGuide,
        icon: null,
        visible: GuideStack.length > 1,
        info: "If you load more than one guide you can go back to the previous guide loaded",
      },
      {
        label: "New Guide",
        method: newGuide,
        icon: null,
        visible: true,
        info: "This will create a new guide and open the new guide. The new guide name will be 'New Guide'",
        videoKey: "build-my-trip",
      },
      {
        label: "Copy Guide",
        method: copyGuide,
        icon: null,
        visible: true,
        info: "This will make a copy of the current guide and open the new guide. The new guide name will be the current guide name appended with '_C'",
        videoKey: "blank-create-reload-clear-guide",
      },
      {
        label: "Overwrite Guide",
        method: overWriteGuide,
        icon: null,
        visible: true,
        info: "This will overwrite a selected guide with the contents of the current guide. It will preserve the ownership of the overwritten file",
      },
      {
        label: "Rate this Guide",
        method: ReviewGuide,
        icon: null,
        visible: true,
        info: "This will allow you to rate the current guide. Note: you need to first download the file. You can only rate the file once, subsequent attempts will allow you to edit the rating",
      },
      {
        label: "Report this Guide",
        method: openReportGuide,
        icon: null,
        visible: canReportGuide(guide_meta, user_info),
        info: "Report a guide someone else made that has sexual, violent, hateful or spam content. Only the Andiamo team sees reports.",
      },
      {
        label: "Upload Images",
        method: ImageUpload,
        icon: null,
        visible: true,
        info: "This will allow you to upload create a new guide and open the new guide. The new guide name will be the current guide name appended with '_C'",
        videoKey: "upload-images",
      },
      {
        label: "Guide Properties",
        method: showGuideInfo,
        icon: null,
        visible: true,
        info: "Display the properties of the guide, e.g. name",
      },
      {
        label: "Email Guide Link",
        method: EmailGuideLink,
        icon: null,
        visible: true,
        info: "Email the link to the current guide. This will allow others to view it. They cannot change it unless you have given them permission",
      },
      {
        label: "Display Guide Link",
        method: DisplayGuideLink,
        icon: null,
        visible: true,
        info: "Display the link to the current guide",
      },
      // { label: "Whatsapp Guide Link", method: null, icon: null, visible: true },
    ];
    setMenuModalBackFn(() => MainMenu);
    setMenuModalList(menuList);
    setMenuModalHeading("Guide Menu");
    setMenuModalImage(<FontAwesomeIcon icon={solid("sticky-note")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  let _attributes = null;

  const ReviewGuide = () => {
    setReviewDialogShow(true);
  };

  const PreviousGuide = () => {
    if (GuideStack.length < 1) {
      dispatch(slice1Actions.clearGuideStack());
      return;
    }
    if (GuideStack.length < 2) return;
    let guide_id = GuideStack[GuideStack.length - 2];
    dispatch(slice1Actions.popGuideStack({ value: null }));
    loadGuide(guide_id);
  };

  const newGuide = () => {
    if (Authorization === AUTHORIZATION_LEVEL.GUEST) {
      myAlert("Message", "Cannot create new guides in guest mode. You must be registered and logged in");
      return;
    }
    myConfirm("This will create a new guide. Save any wanted changes to this guide first. Continue?", [
      { Title: "OK", Method: () => _newGuide() },
      { Title: "CANCEL", Method: null },
    ]);
  };

  const _newGuide = () => {
    dispatch(slice1Actions.SetLoadingGuide({ value: true }));
    setTimeout(timeoutFunc, 5000);
    let new_guide_attributes = new GuideAttributes("New Guide", "", null, "English", 0, [], []);
    newGuideCallback(new_guide_attributes);
  };

  const newGuideCallback = (guideAttributes) => {
    _attributes = guideAttributes;
    let GuideObj = new Guide("new");
    GuideObj.decodeGuideFb(GuideObj, _attributes);
    GuideObj.user_id = user_info.uid;
    DataBase.batchedWriteGuide(GuideObj, null, null, user_info, "new", addGuideDataCallbackNewGuide);
  };

  const addGuideDataCallbackNewGuide = (res) => {
    if (res.pass !== true) {
      dispatch(slice1Actions.SetLoadingGuide({ value: false }));
      return;
    }
    DataBase.readGuideTransaction(res.new_info_ref.id, readGuideDataReturnNew, user_info.uid);
  };

  const copyGuide = () => {
    if (Authorization === AUTHORIZATION_LEVEL.GUEST) {
      myAlert("Cannot copy guides in guest mode. You must be registered and logged in");
      return;
    }
    if (window.guide_obj.isAuthorized(Authorization, AUTHORIZATION_LEVEL.COPY) === false) {
      myAlert("You are not authorized to copy this guide");
      return;
    }
    myConfirm(
      copyConfirmText(window.guide_obj?.attributes),
      [
        { Title: "OK", Method: () => _batchedCopyGuide() },
        { Title: "CANCEL", Method: null },
      ]
    );
  };

  let _copiedGuideID = null;

  const _batchedCopyGuide = () => {
    dispatch(slice1Actions.SetLoadingGuide({ value: true }));
    setTimeout(timeoutFunc, 5000);
    _copiedGuideID = guide_meta?.guide_info_id;
    DataBase.batchedWriteGuide(window.guide_obj, null, null, user_info, "copy", batchCopyGuideCallback);
  };

  const batchCopyGuideCallback = (res) => {
    dispatch(slice1Actions.SetLoadingGuide({ value: false }));
    if (res.pass !== true) {
      myAlert(res.tooLarge ? res.res : "Error copying guide");
      return;
    }
    // this.setState({
    //   new_guide_id: res.new_doc_ref.id,
    //   new_guide_info: res.new_info_ref.id,
    //   guide_info_id: res.new_info_ref.id,
    // });
    DataBase.readGuideTransaction(res.new_info_ref.id, readGuideDataReturnNew, user_info.uid);
    DataBase.incrementCopiesTransaction(_copiedGuideID, incrementCopiesTransaction);
  };

  const incrementCopiesTransaction = () => {};
  //let download_type = "read";

  const overWriteGuide = () => {
    if (window.guide_obj.isAuthorized(Authorization, AUTHORIZATION_LEVEL.COPY) === false) {
      myAlert("Not authorized to copy or write this guide");
      return;
    }
    if (Authorization === AUTHORIZATION_LEVEL.GUEST) {
      myAlert("Cannot overwrite guides in guest mode. You must be registered and logged in");
      return;
    }
    myConfirm("This will update content of another guide with this guide. Continue?", [
      { Title: "OK", Method: () => selectGuideToOverWrite() },
      { Title: "CANCEL", Method: null },
    ]);
  };

  const selectGuideToOverWrite = () => {
    //download_type = "overwrite";
    // setGuideDownloadCallback(_overWriteGuide);
    setGuideDownloadType("overwrite");
    setGuideDownloadMode("list");
    setGuideDownloadShow(true);
  };

  const _overWriteGuide = (guide_info_id, guide_id) => {
    console.log("overwriting guide_id:", guide_id);
    dispatch(slice1Actions.SetLoadingGuide({ value: true }));
    setTimeout(timeoutFunc, 5000);
    DataBase.batchedWriteGuide(
      window.guide_obj,
      guide_id,
      guide_info_id,
      user_info,
      "overwrite",
      overWriteGuideCallback,
      guide_id,
      guide_info_id
    );
  };

  const overWriteGuideCallback = (res) => {
    dispatch(slice1Actions.SetLoadingGuide({ value: false }));
    if (res.pass === true) myAlert("Guide overwritten");
  };

  const DownloadGuide = () => {
    //setGuideDownloadCallback(GuideDownloadCallback);
    //download_type = "read";
    setGuideDownloadType("read");
    setGuideDownloadMode("download");
    setGuideDownloadShow(true);
  };

  const GuideDownloadCallback = (guide_info_id, guide_id) => {
    if (GuideDownloadType === "overwrite") _overWriteGuide(guide_info_id, guide_id);
    else _DownloadGuide(guide_info_id, guide_id);
  };

  const _DownloadGuide = (guide_info_id, guide_id) => {
    console.log("GuideDownloadCallback id:", guide_info_id);
    loadGuide(guide_info_id);

    // Guests have no cloud user profile to persist this to — DataBase's
    // guest guard would reject the write anyway, but with an intrusive
    // "Guest Mode / Saving to the cloud..." alert, which is wrong here: this
    // is passive background bookkeeping (remembering the last guide viewed)
    // that fires on every guide load, not something the user asked to save.
    if (user_info === null || user_info.uid === "guest") return;
    let _user_info = JSON.parse(JSON.stringify(user_info));
    _user_info.last_guide_id = guide_info_id;
    _user_info.last_guide_time = DateTime.now().toISO({ zone: "utc" });
    dispatch(slice1Actions.setUserInfo({ value: _user_info }));
    DataBase.updateUser(_user_info, _user_info.uid, updateUserCallback);
  };

  const updateUserCallback = (res) => {
    console.log("updateUserCallback", res.pass);
  };

  const showGuideInfo = () => {
    //setGuideInfoModal(true);
    setGuideEditModalMode("VIEW");
    setGuideEditModalShow(true);
  };

  const EmailGuideLink = () => {
    document.location.href =
      "mailto:?subject=" +
      encodeURIComponent(`Link to guide`) +
      "&body=" +
      encodeURIComponent(
        `Use this link for the web version: ${guideShareLink(guide_meta.guide_info_id)} or download the mobile app`
      );
  };

  const DisplayGuideLink = () => {
    myAlert(`Guide:link: https://andiamoplaces.com?id=${guide_meta.guide_info_id}`);
  };

  const EditMenu = () => {
    const menuList = [
      {
        label: "Edit Home Content",
        method: HTMLEdit,
        icon: null,
        visible: true,
        info: "Edit the main page of the guide. The content is in HTML",
      },
      {
        label: "Edit Chapters/Sections",
        method: EditSections,
        icon: null,
        visible: true,
        info: "Edit the secondary pages of the guide, which are organized by chapters. These pages are in HTML and can be linked to from other pages",
      },
      {
        label: "Edit Groups",
        method: EditGroups,
        icon: null,
        visible: true,
        info: "Edit the groups of the guide. Groups are used to group places that share a common trait e.g. all places in the same neighborhood",
      },
      {
        label: "Edit Categories",
        method: EditCategories,
        icon: null,
        visible: true,
        info: "Edit the categories of the guide. The categories are used to categorize places, e.g. all restaurants that are vegeterian",
      },
      // { label: "Set Places Category", method: SetCategory, icon: null, visible: true },
      // { label: "Set Places Group", method: SetGroup, icon: null, visible: true },
      // { label: "Set Favorite Places", method: EditFavorite, icon: null, visible: true },
      // { label: "Set Visited Places", method: EditVisited, icon: null, visible: true },
      // { label: "Set Must See Places", method: EditMustSee, icon: null, visible: true },
      // { label: "Set Hidden", method: EditHidden, icon: null, visible: true },
      // { label: "Delete Places", method: DeletePlaces, icon: null, visible: true },
      {
        label: "Edit Guide Properties",
        method: EditGuideInfo,
        icon: null,
        visible: true,
        info: "Edit the attributes of a guide, e.g. guide name",
      },
    ];
    setMenuModalBackFn(() => MainMenu);
    setMenuModalList(menuList);
    setMenuModalHeading("Edit Menu");
    setMenuModalImage(<FontAwesomeIcon icon={solid("pencil")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  const EditGroups = () => {
    setGroupsDialogShow(true);
  };

  const EditCategories = () => {
    setCategoriesDialogShow(true);
  };

  const EditSections = () => {
    setSectionsDialogShow(true);
  };

  let _place_operation = "";

  // const SetCategory = () => {
  //   _place_operation = "Category";
  //   myAlert("Add to or replace Category?", "Add or Replace", [
  //     { Title: "Add", Method: _Add },
  //     { Title: "Replace", Method: _Replace },
  //     { Title: "Cancel", Method: null },
  //   ]);
  // };

  // const SetGroup = () => {
  //   _place_operation = "SetGroup";
  //   myAlert("Add to or replace Group?", "Add or Replace", [
  //     { Title: "Add", Method: _Add },
  //     { Title: "Replace", Method: _Replace },
  //     { Title: "Cancel", Method: null },
  //   ]);
  // };

  // let AddReplaceMode = "Add";

  // const _Add = () => {
  //   AddReplaceMode = "Add";
  //   selectPlaces();
  // };

  // const _Replace = () => {
  //   AddReplaceMode = "Replace";
  //   selectPlaces();
  // };

  // const DeletePlaces = () => {
  //   _place_operation = "Delete Places";
  //   selectPlaces();
  // };

  // const EditFavorite = () => {
  //   _place_operation = "Favorite";
  //   selectPlaces();
  // };

  // const EditVisited = () => {
  //   _place_operation = "Visited";
  //   selectPlaces();
  // };

  // const EditMustSee = () => {
  //   _place_operation = "MustSee";
  //   selectPlaces();
  // };

  // const EditHidden = () => {
  //   _place_operation = "Hidden";
  //   selectPlaces();
  // };

  const EditGuideInfo = () => {
    setGuideEditModalMode("UPDATE");
    setGuideEditModalShow(true);
  };

  // const selectPlaces = () => {
  //   let selectedPlaces = [];
  //   let places = window.guide_obj.places.getPlacesToDisplay(null);
  //   let count = 0;
  //   places.forEach((place) => {
  //     if (
  //       (_place_operation === "Favorite" && place.Favorite === true) ||
  //       (_place_operation === "Visited" && place.Visited === true) ||
  //       (_place_operation === "MustSee" && place.MustSee === true) ||
  //       (_place_operation === "Hidden" && place.Hidden === true) ||
  //       _place_operation === "Category" ||
  //       _place_operation === "SetGroup" ||
  //       _place_operation === "Delete Places"
  //     ) {
  //       selectedPlaces.push({
  //         label: place.name,
  //         name: place.name,
  //         value: place.value,
  //       });
  //       count++;
  //     }
  //   });
  //   //console.log("selectedPlaces, count", selectedPlaces, count);
  //   dispatch(slice1Actions.setMultiselectCallback({ value: selectPlacesCallBack }));
  //   dispatch(slice1Actions.setMultiselectItems({ value: places }));
  //   dispatch(slice1Actions.setMultiselectSelectedItems({ value: selectedPlaces }));
  //   dispatch(slice1Actions.setMultiselectMode({ value: "multi" }));
  //   dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
  //   dispatch(slice1Actions.setShowMultiselect({ value: true }));
  //   // props.navigation.navigate("MultiSelectDialog", {
  //   //   selectionList: places,
  //   //   selectedItems: selectedPlaces,
  //   //   callBack: selectPlacesCallBack,
  //   //   title: "Places",
  //   //   selectText: "Select Places",
  //   // });
  // };

  // let places_selected = [];

  // const selectPlacesCallBack = (Places) => {
  //   if (Places == null) return;
  //   places_selected = Places;
  //   if (_place_operation === "Category") {
  //     if (places_selected.length > 0) setTimeout(selectCategory, 500);
  //     return;
  //   }
  //   if (_place_operation === "SetGroup") {
  //     if (places_selected.length > 0) setTimeout(selectGroup, 500);
  //     return;
  //   }
  //   if (_place_operation === "Delete Places") {
  //     places_selected.forEach((place_id) => {
  //       window.guide_obj.places.deletePlaceById(place_id.value);
  //     });
  //     dispatch(slice1Actions.setGuide({ guide: null }));
  //     return;
  //   }

  //   window.guide_obj.places.setPlaceAttributes(Places, _place_operation);
  //   UpdateDisplay();
  // };

  // const selectCategory = () => {
  //   let _ChooseCategoriesList = window.guide_obj.getCategoriesToDisplay();
  //   // _ChooseCategoriesList.forEach((cat) => {
  //   //   cat.icon = <img src={Place.getItemPOIImage(cat.icon)} />;
  //   // });
  //   dispatch(slice1Actions.setMultiselectCallback({ value: SelectCategoryCallBack }));
  //   dispatch(slice1Actions.setMultiselectItems({ value: _ChooseCategoriesList }));
  //   dispatch(slice1Actions.setMultiselectSelectedItems({ value: [] }));
  //   dispatch(slice1Actions.setMultiselectMode({ value: "uni" }));
  //   dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
  //   dispatch(slice1Actions.setShowMultiselect({ value: true }));
  // };

  // const SelectCategoryCallBack = (category) => {
  //   places_selected.forEach((place_id) => {
  //     let place = window.guide_obj.places.getPlace(place_id.value);
  //     if (place == null) return;
  //     if (AddReplaceMode === "Add") place.Category.push(category[0].id);
  //     else place.Category = [category[0].id];
  //   });
  //   console.log("SelectCategoryCallBack", places_selected, category);
  //   dispatch(slice1Actions.setGuide({ guide: null }));
  // };

  // const selectGroup = () => {
  //   let _ChooseGroupsList = window.guide_obj.getGroupsToDisplay();
  //   dispatch(slice1Actions.setMultiselectCallback({ value: SelectGroupCallBack }));
  //   dispatch(slice1Actions.setMultiselectItems({ value: _ChooseGroupsList }));
  //   dispatch(slice1Actions.setMultiselectSelectedItems({ value: [] }));
  //   dispatch(slice1Actions.setMultiselectMode({ value: "uni" }));
  //   dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
  //   dispatch(slice1Actions.setShowMultiselect({ value: true }));
  // };

  // const SelectGroupCallBack = (groups) => {
  //   places_selected.forEach((place_id) => {
  //     let place = window.guide_obj.places.getPlace(place_id.value);
  //     if (place == null) return;
  //     if (AddReplaceMode === "Add") place.Group.push(groups[0].id);
  //     else place.Group = [groups[0].id];
  //   });
  //   console.log("SelectCategoryCallBack", places_selected, groups);
  //   dispatch(slice1Actions.setGuide({ guide: null }));
  // };

  const UpdateDisplay = () => {
    dispatch(slice1Actions.setGuide({ guide: null }));
    if (GuideFormat === "Photo Mosaic" && window.guide_obj) {
      const html = window.guide_obj.createHTMLItinerary("Main", GuideSettings.itinerary, { ...user_info, showHiddenPlaces: ShowHiddenPlaces }, GuideSettings);
      dispatch(slice1Actions.clearHTMLStack());
      dispatch(slice1Actions.setHomeScreen({ value: html }));
    }
  };

  const GuideEditModalCallback = (guide_attributes) => {
    dispatch(slice1Actions.setGuide({ guide: null, update_guide_attributes: true }));
  };

  const InfoMenu = () => {
    const menuList = [
      {
        label: "About",
        method: handleAbout,
        icon: null,
        visible: true,
        info: "List information about this application",
      },
      {
        label: "Help Videos",
        method: handleHelpVideos,
        icon: null,
        visible: true,
        info: "View videos that explain how to perform certain functions with the app",
      },
      {
        label: "FAQs",
        method: handleFAQs,
        icon: null,
        visible: true,
        info: "Lists Frequently asked Questions (FAQs) about this app",
      },
      {
        label: "Help",
        method: handleDocumentation,
        icon: null,
        visible: true,
        info: "Show the help document for this app",
      },
      {
        label: "Terms of Use",
        method: handleGuidelines,
        icon: null,
        visible: true,
        info: "Lists how users of the app should behave and what is not allowed.",
      },
      {
        label: "Privacy Policy",
        method: handlePrivacyPolicy,
        icon: null,
        visible: true,
        info: "View our privacy policy",
      },
      {
        label: "Contact Us",
        method: handleContactUs,
        icon: null,
        visible: true,
        info: "Send us an email with questions or bug reports",
      },
    ];
    setMenuModalBackFn(() => MainMenu);
    setMenuModalList(menuList);
    setMenuModalHeading("Info Menu");
    setMenuModalImage(<FontAwesomeIcon icon={solid("info")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  function WebSite() {
    const _url = "https://andiamotravelapp.com/";
    let win = window.open(_url, "_blank");
    if (win) win.focus();
  }

  function handleAbout() {
    window.open("/Docs/About.html", "_blank");
  }

  function handleHelpVideos() {
    window.open("/Docs/HelpVideosWeb.html", "_blank");
  }

  function handleDocumentation() {
    window.open("/Docs/DocumentationMobileMode.html", "_blank");
  }

  function handleDocumentationOLD() {
    let htmlString = AppSettings.help_document_web;
    //htmlString = urlSchemeToFunctions(htmlString);
    dispatch(slice1Actions.setHTMLTitle({ value: "Creating a Guide" }));
    dispatch(slice1Actions.setHTMLToSHow({ value: htmlString }));
    dispatch(slice1Actions.setShowHTMLReader({ value: true }));
    window.location.href = "#home-start";
    var homeDiv = document.getElementById("home-content-start");
    if (homeDiv) homeDiv.scrollIntoView();
  }

  function handleFAQs() {
    window.open("/Docs/FAQs.html", "_blank");
  }

  function handleGuidelines() {
    window.open("/Docs/terms-of-use.html", "_blank");
  }

  function handleContactUs() {
    window.location.href = "mailto:andiamotravelapp@gmail.com?subject=Feedback&body=";
  }

  function handlePrivacyPolicy() {
    window.open("/Docs/privacy-policy.html", "_blank");
  }

  const MainMenu = () => {
    const menuList = [
      {
        label: "User ›",
        method: UserMenu,
        icon: null,
        visible: true,
        info: "Display the User menu",
      },
      {
        label: "Edit ›",
        method: EditMenu,
        icon: null,
        visible: true,
        info: "Display the Edit menu",
      },
      {
        label: "Guide ›",
        method: GuideMenu,
        icon: <FontAwesomeIcon icon={solid("sticky-note")} />,
        visible: true,
        info: "Display the Guide menu",
      },
      {
        label: "Tickets",
        method: purchaseTickets,
        icon: null,
        visible: !NoAds,
        info: "Display the travel related Tickets that you can purchase from our sponsors. Note that that you can get a commission from the purchase and help this app stay free.",
      },
      {
        label: "Info ›",
        method: InfoMenu,
        icon: null,
        visible: true,
        info: "Display the Info menu",
      },
    ];
    setMenuModalBackFn(null);
    setMenuModalList(menuList);
    setMenuModalHeading("Main Menu");
    setMenuModalImage(<FontAwesomeIcon icon={solid("bars")} />);
    setMenuModalPlace(null);
    setMenuModalShow(true);
  };

  const SaveGuide = () => {
    if (PreviewingConflictSnapshot) {
      myAlert("Keep or revert the previewed version (see the banner) before saving.");
      return;
    }
    if (Authorization === AUTHORIZATION_LEVEL.GUEST) {
      myAlert("In GUEST mode. Must be logged in to save guides.");
      return;
    }
    if (window.guide_obj.isAuthorized(Authorization, AUTHORIZATION_LEVEL.MODIFY) === false) {
      myAlert("Not authorized to save this guide");
      return;
    }
    //max is 1,024,000
    if (JSON.stringify(window.guide_obj.length) > 1000000) {
      myAlert(
        "Guide is too big (> 1,000,000 bytes. Try making it smaller or splitting it into multiple smaller guides)."
      );
      return;
    }

    myConfirm(`Save this Guide: "${window.guide_obj.attributes.guide_name}" to cloud?`, [
      { Title: "OK", Method: () => _saveGuide() },
      { Title: "CANCEL", Method: null },
    ]);
  };

  const _saveGuide = () => {
    setActivityIndicator(true);
    DataBase.batchedWriteGuide(
      window.guide_obj,
      guide_meta.guide_id,
      guide_meta.guide_info_id,
      user_info,
      "modify",
      batchSaveGuideCallback,
      null,
      null,
      null,
      _expectedMod()
    );
  };

  // Conflict Phase 1 — see HomeHeader.js's _showSaveConflict for the full
  // design rationale; mirrored here since mobile header has its own save path.
  // attributes.mod is a Luxon DateTime object after a fresh load
  // (decodeAttributes) but a plain ISO string right after a save (see the
  // sync-back in batchSaveGuideCallback) — the conflict check compares
  // against Firestore's raw string, so this always normalizes to a string.
  const _expectedMod = () => {
    const mod = window.guide_obj.attributes.mod;
    if (mod == null) return null;
    return typeof mod === "string" ? mod : mod.toISO();
  };

  const _showSaveConflict = (serverGuideInfo) => {
    setActivityIndicator(false);
    const when = serverGuideInfo?.mod
      ? DateTime.fromISO(serverGuideInfo.mod).toLocaleString(DateTime.DATETIME_MED)
      : "just now";
    // owner_name is the guide's OWNER, not necessarily who made this write —
    // a MODIFY-level collaborator could be the one who saved. last_modified_by
    // (a uid, stamped on every save) is the accurate source; look up that
    // user's email (names are optional and often blank).
    if (serverGuideInfo?.last_modified_by) {
      User.findUserByUID(serverGuideInfo.last_modified_by, (res) => {
        const fullName = res?.pass === true ? `${res.res.first_name || ""} ${res.res.last_name || ""}`.trim() : "";
        const who = fullName || (res?.pass === true ? res.res.email : "") || "Someone";
        _showSaveConflictDialog(serverGuideInfo, who, when);
      });
    } else {
      _showSaveConflictDialog(serverGuideInfo, serverGuideInfo?.owner_name || "Someone", when);
    }
  };

  const _showSaveConflictDialog = (serverGuideInfo, who, when) => {
    myConfirm(
      `${who} saved changes to "${serverGuideInfo?.guide_name || window.guide_obj.attributes.guide_name}" at ${when}, after you last loaded it. Your unsaved changes would overwrite theirs if you save now.`,
      [
        {
          Title: "Write Anyway",
          Method: () => _saveGuideWithExpectedMod(serverGuideInfo?.mod),
        },
        {
          Title: "View Changes",
          Method: () => {
            setDiffModalConflict({ serverGuideInfo, who, when });
            setDiffModalShow(true);
          },
        },
        {
          Title: "View Latest Version",
          // Unlike "Load Their Version" below, nothing is discarded —
          // stashed first so the global ConflictPreviewBanner's "Revert to
          // my copy" can restore it. Mirrors HomeHeader.js's identical
          // addition — mobile-mode has its own save path. See the
          // purring-humming-mountain plan.
          Method: () => {
            stashConflictSnapshot(guide_meta.guide_id);
            loadGuide(guide_meta.guide_info_id, (success) => {
              if (success) dispatch(slice1Actions.setPreviewingConflictSnapshot({ value: true }));
            });
          },
        },
        {
          Title: "Load Their Version",
          // Deferred for the same reason as the old "View Their Version"
          // fix — nesting a myConfirm inside this dialog's own button click
          // would otherwise get clobbered by AlertModal's onHide() firing
          // right after Method() in the same batched update.
          Method: () =>
            setTimeout(
              () =>
                myConfirm("Loading their version will discard your unsaved changes to this guide. Continue?", [
                  { Title: "OK", Method: () => loadGuide(guide_meta.guide_info_id) },
                  { Title: "Cancel", Method: null },
                ]),
              0
            ),
        },
        { Title: "Cancel", Method: null },
      ]
    );
  };

  // "View Changes" closes this myConfirm to open the separate diff modal —
  // when that modal closes, bring the same conflict decision back up rather
  // than silently dropping the user with no way back to Write Anyway/Load.
  const _reopenConflictDialogFromDiff = () => {
    setDiffModalShow(false);
    if (diffModalConflict) {
      setTimeout(
        () => _showSaveConflictDialog(diffModalConflict.serverGuideInfo, diffModalConflict.who, diffModalConflict.when),
        0
      );
    }
  };

  const _saveGuideWithExpectedMod = (expectedMod) => {
    setActivityIndicator(true);
    DataBase.batchedWriteGuide(
      window.guide_obj,
      guide_meta.guide_id,
      guide_meta.guide_info_id,
      user_info,
      "modify",
      batchSaveGuideCallback,
      null,
      null,
      null,
      expectedMod
    );
  };

  const batchSaveGuideCallback = (res) => {
    setActivityIndicator(false);
    if (res.pass !== true) {
      if (res.conflict) {
        _showSaveConflict(res.serverGuideInfo);
        return;
      }
      //console.log("batchSaveGuideCallback: Error saving guide", res);
      myAlert(res.tooLarge ? res.res : "Error saving guide");
      return;
    }
    if (res.new_mod) window.guide_obj.attributes.mod = res.new_mod;
    const guideSizeKB = (JSON.stringify(window.guide_obj).length / 1024).toFixed(1);
    myAlert(`Guide "${window.guide_obj.attributes.guide_name}" saved in cloud (${guideSizeKB} KB).${leftoverNamesNote(window.guide_obj)}${res?.sizeWarning ? `\n\n${res.sizeWarning}` : ""}`);
  };

  const showUserInfoModal = () => {
    setUserInfoModal(true);
  };
    const setImageFolder = (folder) => {
      dispatch(slice1Actions.setImageFolder({ value: folder }));
    };

  const bookColor = () => {
    //console.log("Authorization", Authorization);
    if (Authorization === AUTHORIZATION_LEVEL.MODIFY) return COLORS.GREEN;
    else if (Authorization === AUTHORIZATION_LEVEL.COPY) return COLORS.YELLOW;
    else if (Authorization === AUTHORIZATION_LEVEL.READ) return COLORS.ORANGE;
    else if (Authorization === AUTHORIZATION_LEVEL.GUEST) return COLORS.GRAY;
    else return COLORS.GRAY;
  };

  const userColor = () => {
    if (user_info.uid === "guest") return COLORS.GRAY;
    if (Authorization === AUTHORIZATION_LEVEL.GUEST) return COLORS.GRAY;
    return COLORS.GREEN;
  };
  const hideMenuModal = () => {
    dispatch(slice1Actions.setMenuModalArgs({ value: { ...MenuModalArgs, Show: false } }));
  };

  //console.log("******************Authorization", Authorization, user_info, bookColor(), userColor());
  return (
    <>
      <div
        style={{
          display: "flex",
          width: "100%",
          margin: "0px",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "1rem",
        }}
      >
        <div className="mobile-header">
          {HTMLStack.length > 0 ? (
            <div onClick={() => goBack()} style={{ color: "#3598DB", verticalAlign: "middle", textAlign: "center" }}>
              <FontAwesomeIcon icon={solid("arrow-left")} />
              <p>Back</p>
            </div>
          ) : null}
          <div
            style={{
              color: userColor(),
              verticalAlign: "middle",
              textAlign: "center",
            }}
            onClick={() => UserMenu()}
          >
            <FontAwesomeIcon icon={solid("user")} />
            <p>user</p>
          </div>

          <div
            onClick={() => GuideMenu()}
            style={{
              color: bookColor(),
              verticalAlign: "middle",
              textAlign: "center",
            }}
          >
            <div>
              <FontAwesomeIcon icon={solid("sticky-note")} />
            </div>
            <div>
              <p>Guide</p>
            </div>
          </div>

          <div style={{ color: "#3598DB", verticalAlign: "middle", textAlign: "center" }} onClick={() => EditMenu()}>
            <FontAwesomeIcon icon={solid("pencil")} />
            <p>Edit</p>
          </div>

          <div style={{ color: "#3598DB", verticalAlign: "middle", textAlign: "center" }} onClick={() => SaveGuide()}>
            <FontAwesomeIcon icon={solid("save")} />
            <p>Save</p>
          </div>

          {/* <div className="none" style={{ color: "#3598DB", verticalAlign: "middle" }} onClick={() => ImageUpload()}>
            <FontAwesomeIcon icon={solid("ticket")} />
            <p>Upload</p>
          </div> */}

          <div style={{ color: "#3598DB", verticalAlign: "middle", textAlign: "center" }} onClick={() => InfoMenu()}>
            <FontAwesomeIcon icon={solid("info")} />
            <p>Info</p>
          </div>
          {/* <div className="mobile" style={{ color: "#3598DB", verticalAlign: "middle" }} onClick={() => MainMenu()}>
            <FontAwesomeIcon icon={solid("bars")} />
            <p>Menu</p>
          </div> */}
        </div>
      </div>
      {/* <GuideInfo show={guideInfoModal} onHide={() => setGuideInfoModal(false)} /> */}
      <HTMLEditorModal
        show={ShowHTMLEditorModal}
        onHide={() => setHTMLEditorModal(false)}
        html={HTMLEditorModalContent}
        callback={HTMLEditCallback}
        callback_rt={null}
        title={"Home Page"}
      />
      {/* <ImageUploadModal show={ShowImageUploadModal} onHide={() => setImageUploadModal(false)} /> */}
      <UserInfoModal show={ShowUserInfoModal} onHide={() => setUserInfoModal(false)} />
      <LoginModal show={ShowLoginModal} onHide={() => setShowLoginModal(false)} mode={LoginModalMode} />

      <AlertModal
        show={AlertModalShow}
        onHide={() => setAlertModalShow(false)}
        AlertModalTitle={AlertModalTitle}
        AlertModalMessage={AlertModalMessage}
        AlertModalButtons={AlertModalButtons}
      />
      {diffModalShow ? (
        <SaveConflictDiffModal
          show={diffModalShow}
          onHide={_reopenConflictDialogFromDiff}
          serverGuideInfo={diffModalConflict?.serverGuideInfo}
        />
      ) : null}
      <MenuModal
        show={MenuModalShow}
        onHide={() => { setMenuModalShow(false); setMenuModalBackFn(null); }}
        menu_modal_list={MenuModalList}
        menu_modal_heading={MenuModalHeading}
        menu_model_image={MenuModalImage}
        menu_modal_place={MenuModalPlace}
        onBack={MenuModalBackFn || undefined}
      />
      <GuideDownload
        show={GuideDownloadShow}
        onHide={() => setGuideDownloadShow(false)}
        user_info={user_info}
        guide_sort_option={GuideSortOption}
        set_guide_sort_option={setGuideSortOption}
        callback={GuideDownloadCallback}
        mode={GuideDownloadMode}
        modify_only={"true"}
        guide_meta={guide_meta}
      />
      <ImageDialog
        show={ImageDialogShow}
        onHide={() => setImageDialogShow(false)}
        user_info={user_info}
        callback={ImageDialogCallback}
        mode={"upload"}
        modify_only={"true"}
        updateImage={null}
        size={"sm"}
        multi={true}
        exif={false}
            folder={imageFolder}
            setImageFolder={setImageFolder}
      />
      <GroupsDialog show={GroupsDialogShow} onHide={() => setGroupsDialogShow(false)} update_display={UpdateDisplay} />
      <CategoriesDialog
        show={CategoriesDialogShow}
        onHide={() => setCategoriesDialogShow(false)}
        update_display={UpdateDisplay}
      />
      {/* <Offcanvas show={CategoriesDialogShow} onHide={() => setCategoriesDialogShow(false)}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Offcanvas</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body> */}
      <CategoriesDialog
        show={CategoriesDialogShow}
        onHide={() => setCategoriesDialogShow(false)}
        update_display={UpdateDisplay}
      />
      {SettingsDialogShow ? (
        <SettingsDialog
          show={SettingsDialogShow}
          onHide={() => setSettingsDialogShow(false)}
          user_info={user_info}
          user_info_id={user_info_id}
          callback={SettingsDialogCallback}
        />
      ) : null}

      {/* </Offcanvas.Body>
      </Offcanvas> */}

      {SectionsDialogShow ? (
        <SectionsDialog
          show={SectionsDialogShow}
          onHide={() => setSectionsDialogShow(false)}
          update_display={UpdateDisplay}
          mode={"edit"}
          callback={null}
        />
      ) : null}
      {ReviewDialogShow ? (
        <ReviewDialog
          show={ReviewDialogShow}
          onHide={() => setReviewDialogShow(false)}
          user_info={user_info}
          guide_info_id={guide_meta.guide_info_id}
          guide_info={guide_meta.guide_info}
        />
      ) : null}
      {GuideEditModalShow ? (
        <GuideEditModal
          show={GuideEditModalShow}
          onHide={() => setGuideEditModalShow(false)}
          guide_meta={guide_meta}
          guide_info={guide_meta.guide_info}
          guide_info_id={guide_meta.guide_info_id}
          user_info={user_info}
          mode={GuideEditModalMode}
          callback={GuideEditModalCallback}
          folder={imageFolder}
          setImageFolder={setImageFolder}
        />
      ) : null}
    </>
  );
};

export default MobileHeader;
